module.exports = __webpack_public_path__ + "static/media/home-no-updates.7a3d2824.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/home-no-updates.svg
// module id = 366
// module chunks = 0